import {
  ON_CLICK_MEDIA,
  SET_EXPAND_STATE,
  SET_COMMENTS,
  ADD_COMMENTS,
  SET_COMMENTS_PAGING,
  COMMENTS_LOADING,
  EXPAND_ON_ADD_MEDIAS,
  EXPAND_IS_LOADING_MORE_MEDIAS,
  SET_MEDIA_LINKS,
  SET_MEDIA_LINKS_LOADING,
  UPDATE_STORY_PROGRESS,
  SET_POSTS,
  SET_STORIES,
} from '../constants';

export const initState = {
  currentMedia: {},
  currentIndex: 0,
  medias: [],
  pagination: {},
  user: {},
  comments: {},
  commentsPagination: {},
  loadingComments: {},
  isLodingMedias: false,
  mediaLinks: {},
  loadingMediaLinks: {},
  posts: [],
  stories: [],
};

const Reducer = (state = initState, action) => {
  switch (action.type) {
    case ON_CLICK_MEDIA:
      return {
        ...state,
        currentMedia: action.payload.media,
        currentIndex: action.payload.index,
      };
    case SET_EXPAND_STATE:
      return {
        ...state,
        ...action.payload,
        isLodingMedias: false,
      };
    case ADD_COMMENTS:
      return {
        ...state,
        comments: {
          ...state.comments,
          [action.payload.mediaId]: state.comments[
            action.payload.mediaId
          ].concat(action.payload.newData),
        },
      };
    case SET_COMMENTS:
      return {
        ...state,
        comments: {
          ...state.comments,
          [action.payload.mediaId]: action.payload.newData,
        },
      };
    case SET_COMMENTS_PAGING:
      return {
        ...state,
        commentsPagination: {
          ...state.commentsPagination,
          ...action.payload,
        },
      };
    case COMMENTS_LOADING:
      return {
        ...state,
        loadingComments: {
          ...state.loadingComments,
          ...action.payload,
        },
      };
    case EXPAND_IS_LOADING_MORE_MEDIAS:
      return {
        ...state,
        isLodingMedias: action.payload,
      };
    case EXPAND_ON_ADD_MEDIAS:
      return {
        ...state,
        medias: state.medias.concat(action.payload.medias),
        pagination: action.payload.pagination,
        isLodingMedias: false,
      };
    case SET_MEDIA_LINKS:
      return {
        ...state,
        mediaLinks: {
          ...state.mediaLinks,
          [action.payload.mediaId]: action.payload.newData,
        },
      };
    case SET_MEDIA_LINKS_LOADING:
      return {
        ...state,
        loadingMediaLinks: {
          ...state.loadingMediaLinks,
          ...action.payload,
        },
      };
    case UPDATE_STORY_PROGRESS:
      let currentMedia;
      const mediasToSet = state.medias.map((media, index) => {
        if (index === action.storyIndex) {
          currentMedia = { ...media, progress: action.progress };
          return currentMedia;
        }
        return media;
      });
      return {
        ...state,
        medias: mediasToSet,
        currentMedia,
      };
    case SET_POSTS:
      return {
        ...state,
        medias: [...state.posts],
        currentIndex: 0,
        currentMedia: state.posts[0],
      };
    case SET_STORIES:
      return {
        ...state,
        medias: [...state.stories],
        currentIndex: 0,
        currentMedia: state.stories[0],
      };
    default:
      return state;
  }
};

export default Reducer;
